import { VIDEO_TYPE } from '@/helpers';

export default {
  name: 'YoutubeModal',
  props: {
    link: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      VIDEO_TYPE,
      videoType: VIDEO_TYPE.YOUTUBE_NORMAL,
      videoLink: null
    };
  },
  created() {
    let urlObj = new URL(this.link);
    if (urlObj.pathname.includes('/shorts/')) {
      this.videoType = VIDEO_TYPE.YOUTUBE_SHORTS;
      let videoId = urlObj.pathname.split('/').pop().split('?')[0];
      this.videoLink = `https://www.youtube.com/embed/${videoId}`;
    } else {
      this.videoLink = this.link;
    }
  }
};
